import PropertyCard from "@/components/common/PropertyCard";
import { getEffectiveStatus } from "@/utils/propertyStatus";

interface Property {
  id: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  price: number;
  bedrooms: number;
  bathrooms: number;
  square_feet: number;
  image_url: string | null;
  created_at: string;
  status: string;
  closed_date: string | null;
  contract_expiration_date: string | null;
  seller_id: string;
}

interface PropertyGridProps {
  properties: Property[];
  daysOnSite: (createdAt: string) => number;
}

export const PropertyGrid = ({ properties, daysOnSite }: PropertyGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
      {properties.map((property, index) => (
        <div key={property.id} {...(index === 0 ? { 'data-tour': 'status-badge' } : {})}>
          <PropertyCard
            id={property.id}
            address={property.address}
            city={property.city}
            state={property.state}
            zip={property.zip_code}
            price={property.price}
            bedrooms={property.bedrooms}
            bathrooms={property.bathrooms}
            squareFeet={property.square_feet}
            imageUrl={property.image_url || "/placeholder.svg"}
            daysOnSite={daysOnSite(property.created_at)}
            status={getEffectiveStatus(property.status, property.closed_date, property.contract_expiration_date)}
            sellerId={property.seller_id}
          />
        </div>
      ))}
    </div>
  );
};
